import { useEffect } from 'react';
import { notificationService } from 'services/NotificationService';

export function useNotifications(userId: string, onLive: (msg: any) => void) {
  useEffect(() => {
    if (!userId) return;

    notificationService.connect(userId);
    const unsubscribe = notificationService.subscribe(onLive);

    return () => {
      unsubscribe();
      notificationService.disconnect();
    };
  }, [userId, onLive]);
}
